module.exports = __webpack_public_path__ + "Path 264530.de0ead3f508cfc894ec0.png";